import { insertInArray, removeFromArray, reorderArray } from 'utils/helpers';

/**
 * shouldStateUpdate
 * helper function that declares whether the ToggleColumnsModal's
 * shouldComponentUpdate function should update state.
 * @returns { Boolean }
 */
export const shouldStateUpdate = (nextProps, props = {}) => {
  const { open } = nextProps;
  return open && open !== props.open;
};

/**
 * setSelectedColumns
 * helper function that returns the selected columns value by filtering from `columns`.
 */
export const getSelectedColumns = (props) => {
  const { columns, visibleColumns } = props;
  const selectedColumns = visibleColumns.length
    ? visibleColumns
    : columns.map(({ value }) => value);
  return { selectedColumns, reordered: false };
};

/**
 * getChangeToggleColumns
 * helper function that gets the correct columns to display when a toggle is checked
 */
export const getChangeToggleColumns = (state, { checked, id, value }) => {
  const { selectedColumns } = state;
  return checked
    ? { selectedColumns: insertInArray(selectedColumns, id, value) }
    : { selectedColumns: removeFromArray(selectedColumns, id, value) };
};

/**
 * getHandleReorderColumns
 * helper function that returns the state to update when the columns are reordered.
 */
export const getHandleReorderColumns = (state, itemIndex, newIndex) => {
  const { selectedColumns } = state;
  return {
    selectedColumns: reorderArray(selectedColumns, itemIndex, newIndex),
    reordered: true,
  };
};
